import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import logo from "./../images/logo.png";
import { Search } from "./Search";
import { onAuthStateChanged } from "firebase/auth";
import { auth, db } from "./../config/firebase";
import { signOut } from "firebase/auth";
import { useNavigate } from "react-router-dom";
import { getDoc } from "firebase/firestore";
import { doc } from "firebase/firestore";
import { shortName } from "../helpersFunction/shortName";
import { PersonalCart } from "./PersonalCart";

export const NavBar = () => {
  const [currentUser, setCurrentUser] = useState({});
  const [showMore, setShowMore] = useState(false);
  const navigate = useNavigate();

  const handleSignOut = async () => {
    try {
      await signOut(auth);
      navigate("/");
      console.log("User Sign Out successfully");
    } catch (error) {
      console.error("Error signing out:", error);
    }
  };

  useEffect(() => {
    onAuthStateChanged(auth, async (user) => {
      try {
        if (user) {
          const uid = user.uid;
          const currentUsersDocRef = doc(db, "users", uid);
          const additionalUserData = await getDoc(currentUsersDocRef);
          setCurrentUser({ ...additionalUserData.data(), uid: uid });
          console.log("Get user additional data with uid");
        } else {
          setCurrentUser(null);
          setShowMore(false);
        }
      } catch (error) {
        console.error("Error fetching user additional data:", error);
      }
    });
  }, []);

  return (
    <div className="bg-green-600 h-20 px-10 flex items-center justify-between">
      <div className="flex items-center">
        <Link to="/">
          <img src={logo} alt="logo" className="w-48" />
        </Link>
      </div>
      <div className="flex items-center">
        <div className="hidden md:block">
          <Search />
        </div>

        {!currentUser?.uid ? (
          <Link
            to="signin"
            className="flex w-28 items-center justify-center h-12 px-5 active:bg-gray-100 rounded-3xl border-none bg-gray-50 ml-5 text-gray-950 text-lg font-semibold hover:shadow-lg outline-none focus:outline-none"
          >
            Sign In
          </Link>
        ) : (
          <div className="relative">
            <button
              onClick={() => setShowMore(!showMore)}
              className="flex items-center h-12 px-7 active:bg-gray-100 rounded-3xl border-none bg-gray-50 ml-5 text-gray-950 text-lg font-semibold hover:shadow-lg outline-none focus:outline-none"
            >
              {shortName(currentUser.fullname)}
            </button>
            {showMore && (
              <PersonalCart
                currentUser={currentUser}
                handleSignOut={handleSignOut}
              />
            )}
          </div>
        )}
      </div>
    </div>
  );
};
